// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PurchasePlanReceipt-purchasePlanPaymentContainer-iY0ch {
    margin-top: 32px;
}

.PurchasePlanReceipt-container-R5Ugt {
    width: 100%;
    max-width: var(--max-listing-width);
    margin: 0 auto;
    padding-left: 15px;
    padding-right: 15px;
}

.PurchasePlanReceipt-purchasePlanPaymentRow-CWo5I {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
}

.PurchasePlanReceipt-purchasePlanPaymentCol-ga_AQ {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

.PurchasePlanReceipt-purchasePlanPaymentHeader-JX6ZW {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 24px;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.PurchasePlanReceipt-purchasePlanPrintBtnIcon-iX5uL {
    width: 22px;
    height: 23px;
    margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/routes/userServicePlan/PurchasePlanReceipt/PurchasePlanReceipt.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".purchasePlanPaymentContainer {\n    margin-top: 32px;\n}\n\n.container {\n    width: 100%;\n    max-width: var(--max-listing-width);\n    margin: 0 auto;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.purchasePlanPaymentRow {\n    display: flex;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n    justify-content: space-between;\n}\n\n.purchasePlanPaymentCol {\n    width: 100%;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n\n.purchasePlanPaymentHeader {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.purchasePlanPrintBtnIcon {\n    width: 22px;\n    height: 23px;\n    margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"purchasePlanPaymentContainer": `PurchasePlanReceipt-purchasePlanPaymentContainer-iY0ch`,
	"container": `PurchasePlanReceipt-container-R5Ugt`,
	"purchasePlanPaymentRow": `PurchasePlanReceipt-purchasePlanPaymentRow-CWo5I`,
	"purchasePlanPaymentCol": `PurchasePlanReceipt-purchasePlanPaymentCol-ga_AQ`,
	"purchasePlanPaymentHeader": `PurchasePlanReceipt-purchasePlanPaymentHeader-JX6ZW`,
	"purchasePlanPrintBtnIcon": `PurchasePlanReceipt-purchasePlanPrintBtnIcon-iX5uL`
};
module.exports = ___CSS_LOADER_EXPORT___;
